import { render, staticRenderFns } from "./QuestionEditor.vue?vue&type=template&id=6fcd480d&scoped=true"
import script from "./QuestionEditor.vue?vue&type=script&lang=js"
export * from "./QuestionEditor.vue?vue&type=script&lang=js"
import style0 from "./QuestionEditor.vue?vue&type=style&index=0&id=6fcd480d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd480d",
  null
  
)

export default component.exports